// flirto analytics helpers.
//
// All analytics flows through GTM (TagManager.dataLayer, container GTM-N8LQSVFS
// initialized in App.js). This lander never talks to Mixpanel directly — the
// shared GTM container holds the Mixpanel token. `lp_source` lets the shared
// container tell swipeychat traffic apart from the other landers.

import TagManager from "react-gtm-module";
import { LP_SOURCE } from "./api";

// Every event carries `lp_source`. Spread caller params last so an explicit
// override still wins.
export function trackEvent(eventName, params = {}) {
  try {
    TagManager.dataLayer({
      dataLayer: {
        event: eventName,
        lp_source: LP_SOURCE,
        ...params,
      },
    });
    return true;
  } catch {
    return false;
  }
}

// === Quiz funnel (GTM-only) ===
// Fires once per quiz question screen as it is shown (step_1 … step_11) — NOT on
// answer. `stepName` is the QUIZ_STEPS key, sent only for debuggability.
export function trackQuizStep(stepNumber, stepName) {
  return trackEvent(`step_${stepNumber}`, { step_name: stepName });
}

// === Registration / auth ===
// Fires when the registration form opens. GTM-only.
export function trackRegistrationModal() {
  return trackEvent("lander_registration_modal");
}

// Registration succeeded. Carries the registered `email` in the dataLayer.
export function trackLanderRegistrationCompleted(email) {
  return trackEvent("lander_registration_completed", { email });
}

// Fires on successful email/password login. GTM-only.
export function trackLoginCompleted() {
  return trackEvent("lander_login_completed");
}

// Fires after a password reset successfully completes (new password set).
// GTM-only.
export function trackForgotPasswordCompleted() {
  return trackEvent("lander_forgot_pass_completed");
}
